
import Bitmap = createjs.Bitmap;
import BitmapData = createjs.BitmapData;
import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import Sprite = createjs.Sprite;
import ColorTransform = createjs.ColorTransform;
import Matrix2D = createjs.Matrix2D;
import Point = createjs.Point;
// import Rectangle = createjs.Rectangle;

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("TiledBitmap");

export class TiledBitmap extends Container {
    protected static MAX_ARCHIVE_WIDTH: number = /* 2 */ 1024;
    protected static MAX_ARCHIVE_HEIGHT: number = /* 1 */ 512;
    protected static CLEAR_ARCHIVE_BITMAP: BitmapData = new BitmapData(TiledBitmap.MAX_ARCHIVE_WIDTH, TiledBitmap.MAX_ARCHIVE_HEIGHT, true, 0x00000000);

    protected static MAX_WIDTH: number = 2048;
    protected static MAX_HEIGHT: number = 2048;

    protected static bitmapArchive: any[] = new Array();

    protected _width: number;
    protected _height: number;

    private _rectBitmapDict: Map<any, any>;
    private rectCount: number = 0;
    private _bitmaps: any[];
    private _transparent: boolean;
    private _color: number;
    private _matrix: Matrix2D;
    private _smoothing: boolean;

    constructor(w: number, h: number, smoothing: boolean, transparent: boolean = true, color: number = 0xffffff) {
        super();

        // TODO: @HTML5 - Container mismatch from AS3 API
        // see 'draw' and all other commented methods.
        logger.warn("TiledBitmap has major createjs incompatibilities");

        this._width = Math.floor(w);
        this._height = Math.floor(h);
        this._smoothing = smoothing;
        this._transparent = transparent;
        this._color = color;
        //makeBitmaps();
        this._bitmaps = new Array();
        this.makeRects();
    }

    public set matrix(value: Matrix2D) {
        this._matrix = value;
    }

    private makeRects(): void {
        this._rectBitmapDict = new Map<any, any>();

        let h: number = Math.floor(this._height);
        let ypos: number = 0;

        while (h > 0) {
            let rect: Rectangle;
            let xpos: number = 0;
            let w: number = this._width;

            if (h >= 0 && h < TiledBitmap.MAX_ARCHIVE_HEIGHT) {
                let lastRowWidth: number = w;
                let lastRowX: number = 0;

                while (lastRowWidth > 0) {
                    rect = new Rectangle(lastRowX, ypos, Math.min(TiledBitmap.MAX_WIDTH, lastRowWidth), h);
                    //trace(new Date().time + " - Created new bitmap! width: "+bmp.width+"; height: "+bmp.height);
                    this._rectBitmapDict.set(rect, null);
                    lastRowWidth -= rect.width;
                    lastRowX += rect.width;
                }
                h = 0;
                continue;
            }

            while (w > 0) {
                if (w >= TiledBitmap.MAX_ARCHIVE_WIDTH) {
                    rect = new Rectangle(0, 0, Math.min(TiledBitmap.MAX_ARCHIVE_WIDTH, w), Math.min(TiledBitmap.MAX_ARCHIVE_HEIGHT, h));
                }
                else {
                    if (ypos == 0) {
                        let lastColumnHeight: number = h > TiledBitmap.MAX_ARCHIVE_HEIGHT ? h - (h % TiledBitmap.MAX_ARCHIVE_HEIGHT) : h;
                        let lastColumnY: number = 0;

                        while (lastColumnHeight > 0) {
                            rect = new Rectangle(xpos, lastColumnY, Math.min(TiledBitmap.MAX_ARCHIVE_WIDTH, w), Math.min(TiledBitmap.MAX_ARCHIVE_HEIGHT, h));
                            this._rectBitmapDict.set(rect, null);
                            lastColumnHeight -= rect.height;
                            lastColumnY += rect.height;
                        }
                    }
                    w = 0;
                    continue;
                }
                rect.x = xpos;
                rect.y = ypos;
                this._rectBitmapDict.set(rect, null);
                w -= rect.width;
                xpos += rect.width;
            }
            ypos += TiledBitmap.MAX_ARCHIVE_HEIGHT;
            h -= TiledBitmap.MAX_ARCHIVE_HEIGHT;
        }

        this.rectCount = this._rectBitmapDict.size;
    }

    private addBitmap(bmp: Bitmap, xpos: number, ypos: number): void {
        if (bmp.width == TiledBitmap.MAX_ARCHIVE_WIDTH && bmp.height == TiledBitmap.MAX_ARCHIVE_HEIGHT && TiledBitmap.bitmapArchive.indexOf(bmp) == -1) {
            TiledBitmap.bitmapArchive.push(bmp);
        }
        bmp.x = xpos;
        bmp.y = ypos;
        this.addChild(bmp);
        this._bitmaps.push(bmp);
    }

    // public drawBounds(disp: DisplayObject, tx: number = 0, ty: number = 0): void {
    //     if (disp == null) {
    //         return;
    //     }
    //
    //     let matrix: Matrix2D = new Matrix2D();
    //     matrix.tx = tx;
    //     matrix.ty = ty;
    //
    //     //matrix.a = disp.scaleX;
    //     //matrix.d = disp.scaleY;
    //
    //     if (this._matrix != null) {
    //         matrix.appendMatrix(this._matrix);
    //     }
    //     let srcBounds: Rectangle = disp.getBounds();
    //     this.draw(disp, matrix, disp.transform.colorTransform, null, srcBounds, true);
    // }
    //
    // public draw(source: DisplayObject, matrix: Matrix2D = null, colorTransform: ColorTransform = null, blendMode: string = null, srcBounds: Rectangle = null, smoothing: boolean = false): void {
    //     if (matrix == null) {
    //         matrix = new Matrix2D();
    //     }
    //     srcBounds.topLeft = matrix.transformPoint(srcBounds.topLeft);
    //     srcBounds.bottomRight = matrix.transformPoint(srcBounds.bottomRight);
    //     let bmCount: number = 0;
    //
    //     for (let [key, _] of this._rectBitmapDict) {
    //         let rect: Rectangle = (<Rectangle>key);
    //         let temp: Matrix2D = matrix.clone();
    //         temp.tx -= rect.x;
    //         temp.ty -= rect.y;
    //
    //         if (srcBounds.intersects(rect)) {
    //             let bmp: Bitmap = (<Bitmap>this._rectBitmapDict.get(rect));
    //
    //             if (bmp == null) {
    //                 if (rect.width == TiledBitmap.MAX_ARCHIVE_WIDTH && rect.height == TiledBitmap.MAX_ARCHIVE_HEIGHT) {
    //                     for (let archivedBitmap of TiledBitmap.bitmapArchive) {
    //                         if (archivedBitmap.parent == null) {
    //                             bmp = archivedBitmap;
    //                             this.clearBitmap(bmp);
    //                             break;
    //                         }
    //                     }
    //                 }
    //
    //                 if (bmp == null) {
    //                     bmp = new Bitmap(new BitmapData(rect.width, rect.height, this._transparent, this._color), "auto", this._smoothing);
    //                 }
    //                 this.addBitmap(bmp, rect.x, rect.y);
    //                 this._rectBitmapDict.set(rect, bmp);
    //             }
    //             bmp.bitmapData.draw(source, temp, colorTransform, blendMode, null, smoothing);
    //             //trace("Single Drawing took "+(Date.now()-beforeSingle)+" ms!");
    //             bmCount++;
    //         }
    //     }
    //     //trace("Drawing took "+(Date.now()-before)+" ms! Affected bitmaps: "+bmCount);
    // }
    //
    // public updateVisibility(visibleRect: Rectangle): void {
    //     let visCount: number = 0;
    //
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         bmp.visible = visibleRect.intersects(new Rectangle(bmp.x, bmp.y, bmp.width, bmp.height));
    //
    //         if (bmp.visible) {
    //             visCount++;
    //         }
    //     }
    //     //trace("visible: "+visCount+" of "+_bitmaps.length+" ("+rectCount+")");
    // }
    //
    // public set filters(value: any[]) {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         bmp.filters = value;
    //     }
    // }
    //
    // public reset(newW: number, newH: number): void {
    //     if (newW != this._width || newH != this._height) {
    //         this.dispose();
    //         this._width = newW;
    //         this._height = newH;
    //         //makeBitmaps();
    //         this.makeRects();
    //     }
    //     else {
    //         this.clear();
    //     }
    // }
    //
    // public clear(): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         this.clearBitmap((<Bitmap>this._bitmaps[i]));
    //     }
    // }
    //
    // protected clearBitmap(bmp: Bitmap): void {
    //     bmp.bitmapData.lock();
    //
    //     if (bmp.bitmapData.width == TiledBitmap.MAX_ARCHIVE_WIDTH && bmp.bitmapData.height == TiledBitmap.MAX_ARCHIVE_HEIGHT) {
    //         bmp.bitmapData.copyPixels(TiledBitmap.CLEAR_ARCHIVE_BITMAP, TiledBitmap.CLEAR_ARCHIVE_BITMAP.rect, new Point());
    //     }
    //     else {
    //         bmp.bitmapData.fillRect(bmp.bitmapData.rect, 0);
    //     }
    //     bmp.bitmapData.unlock();
    // }
    //
    // public dispose(): void {
    //     while (this._bitmaps.length > 0) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps.shift());
    //         this.removeChild(bmp);
    //
    //         if (TiledBitmap.bitmapArchive.indexOf(bmp) == -1) {
    //             bmp.bitmapData.dispose();
    //             bmp.bitmapData = null;
    //         }
    //     }
    // }
    //
    // public fillRect(rect: Rectangle, color: number): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         let temp: Rectangle = rect.clone();
    //         temp.x -= bmp.x;
    //         temp.y -= bmp.y;
    //         bmp.bitmapData.fillRect(temp, color);
    //     }
    // }
    //
    // public copyPixelsOut(rect: Rectangle, transparent: boolean = true, fillColor: number = 0x00000000): BitmapData {
    //     let bitmapData: BitmapData = new BitmapData(rect.width, rect.height, true, fillColor);
    //
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         let temp: Rectangle = rect.clone();
    //         temp.x -= bmp.x;
    //         temp.y -= bmp.y;
    //
    //         if (temp.intersects(new Rectangle(0, 0, TiledBitmap.MAX_ARCHIVE_WIDTH, TiledBitmap.MAX_ARCHIVE_HEIGHT))) {
    //             bitmapData.copyPixels(bmp.bitmapData, temp, new Point());
    //         }
    //     }
    //
    //     return bitmapData;
    // }
    //
    // public copyPixelsIn(bitmapData: BitmapData, m: Matrix2D, transparent: boolean = true, fillColor: number = 0x00000000): BitmapData {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         let temp: Rectangle = new Rectangle(m.tx * m.a, m.ty * m.d, bitmapData.width, bitmapData.height);
    //         temp.x -= bmp.x;
    //         temp.y -= bmp.y;
    //
    //         if (temp.intersects(new Rectangle(0, 0, TiledBitmap.MAX_ARCHIVE_WIDTH, TiledBitmap.MAX_ARCHIVE_HEIGHT))) {
    //             bitmapData.copyPixels(bmp.bitmapData, temp, new Point());
    //         }
    //     }
    //
    //     return bitmapData;
    // }
    //
    // public getPixel(x: number, y: number): number {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //
    //         if (x >= bmp.x && x < bmp.x + bmp.width && y >= bmp.y && y < bmp.y + bmp.height) {
    //             return bmp.bitmapData.getPixel(x - bmp.x, y - bmp.y);
    //         }
    //     }
    //     return 0;
    // }
    //
    // public setPixel(x: number, y: number, color: number): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //
    //         if (x >= bmp.x && x < bmp.x + bmp.width && y >= bmp.y && y < bmp.y + bmp.height) {
    //             bmp.bitmapData.setPixel(Math.round(x - bmp.x), Math.round(y - bmp.y), color);
    //         }
    //     }
    // }
    //
    // public getPixel32(x: number, y: number): number {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //
    //         if (x >= bmp.x && x < bmp.x + bmp.width && y >= bmp.y && y < bmp.y + bmp.height) {
    //             return bmp.bitmapData.getPixel32(x - bmp.x, y - bmp.y);
    //         }
    //     }
    //     return 0;
    // }
    //
    // public setPixel32(x: number, y: number, color: number): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //
    //         if (x >= bmp.x && x < bmp.x + bmp.width && y >= bmp.y && y < bmp.y + bmp.height) {
    //             bmp.bitmapData.setPixel32(x - bmp.x, y - bmp.y, color);
    //         }
    //     }
    // }
    //
    // public noise(randomSeed: number, low: number = 0, high: number = 255, channelOptions: number = 7, grayScale: boolean = false): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         bmp.bitmapData.noise(randomSeed, low, high, channelOptions, grayScale);
    //     }
    // }
    //
    // public perlinNoise(baseX: number, baseY: number, numOctaves: number, randomSeed: number, fractalNoise: boolean, channelOptions: number = 7, grayScale: boolean = false): void {
    //     let offsets: any[] = new Array();
    //
    //     for (let i: number = 0; i < numOctaves; i++) {
    //         offsets.push(new Point());
    //     }
    //
    //     for (i = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         let temp: any[] = new Array();
    //
    //         for (let j: number = 0; j < offsets.length; j++) {
    //             temp[j] = new Point(offsets[j].x + bmp.x, offsets[j].y + bmp.y);
    //         }
    //         bmp.bitmapData.perlinNoise(baseX, baseY, numOctaves, randomSeed, false, fractalNoise, channelOptions, grayScale, temp);
    //     }
    // }
    //
    // public lock(): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         bmp.bitmapData.lock();
    //     }
    // }
    //
    // public unlock(): void {
    //     for (let i: number = 0; i < this._bitmaps.length; i++) {
    //         let bmp: Bitmap = (<Bitmap>this._bitmaps[i]);
    //         bmp.bitmapData.unlock();
    //     }
    // }

    public get bitmapWidth(): number {
        return this._width;
    }

    public get bitmapHeight(): number {
        return this._height;
    }

}
